enum BudgetType {
  REVENUES_TOTAL = 'revenues_total',
  REVENUES_CROP = 'revenues_crop',
  REVENUES_ANIMAL = 'revenues_animal',
  REVENUES_STATE_AID = 'revenues_stateAid',
  REVENUES_OTHER = 'revenues_other',
  COSTS_TOTAL = 'costs_total',
  COSTS_CROP = 'costs_crop',
  COSTS_CROP_SEED = 'costs_crop_seed',
  COSTS_CROP_FERTILIZERS = 'costs_crop_fertilizers',
  COSTS_CROP_PLANT = 'costs_crop_plant',
  COSTS_CROP_SERVICES = 'costs_crop_services',
  COSTS_CROP_FUEL = 'costs_crop_fuel',
  COSTS_CROP_OTHER = 'costs_crop_other',
  COSTS_ANIMAL = 'costs_animal',
  COSTS_ANIMAL_FODDER = 'costs_animal_fodder',
  COSTS_ANIMAL_VETERINARY = 'costs_animal_veterinary',
  COSTS_ANIMAL_INSEMINATION = 'costs_animal_insemination',
  COSTS_ANIMAL_ANIMALS = 'costs_animal_animals',
  COSTS_ANIMAL_MONITORING = 'costs_animal_monitoring',
  COSTS_ANIMAL_FUEL = 'costs_animal_fuel',
  COSTS_ANIMAL_OTHER = 'costs_animal_other',
  GROSS_PROFIT = 'gross_profit',
  GROSS_PROFITABILITY = 'gross_profitability',
  CATEGORIZED_COSTS_ANIMAL = 'categorized_costs_animal',
  CATEGORIZED_COSTS_CROP = 'categorized_costs_crop',
  TOTAL_PRODUCTION_COSTS = 'total_production_costs',
  TOTAL_PRODUCTION_COSTS_FUEL = 'total_production_costs_fuel',
  TOTAL_PRODUCTION_COSTS_ELECTRICITY = 'total_production_costs_electricity',
  TOTAL_PRODUCTION_COSTS_UTILITIES = 'total_production_costs_utilities',
  TOTAL_PRODUCTION_COSTS_SALARY = 'total_production_costs_salary',
  TOTAL_PRODUCTION_COSTS_TAXES = 'total_production_costs_taxes',
  TOTAL_PRODUCTION_COSTS_ADMINISTRATION = 'total_production_costs_administration',
  TOTAL_PRODUCTION_COSTS_INSURANCE = 'total_production_costs_insurance',
  TOTAL_PRODUCTION_COSTS_TRANSPORT = 'total_production_costs_transport',
  TOTAL_PRODUCTION_COSTS_RENT = 'total_production_costs_rent',
  TOTAL_PRODUCTION_COSTS_EQUIPMENT = 'total_production_costs_equipment',
  TOTAL_PRODUCTION_COSTS_BUILDING_REPAIR = 'total_production_costs_buildingRepair',
  TOTAL_PRODUCTION_COSTS_OTHER = 'total_production_costs_other',
  EBITDA = 'EBITDA',
  EQUIPMENT = 'equipment',
  BUILDINGS = 'buildings',
  EBIT = 'EBIT',
  LOAN_PAYMENTS = 'loan_payments',
  NET_PROFIT = 'net_profit',
  WITHOUT_AREA_PAYMENTS = 'without_area_payments',
  TDS = 'TDS',
  DSCR = 'DSCR',
}

export default BudgetType;
